import { createActions } from 'redux-actions';

export const { setDashboardIncome, clearDashboardIncome } = createActions(
  'SET_DASHBOARD_INCOME',
  'CLEAR_DASHBOARD_INCOME',
);
